"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeaderCell = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _TableHeaderCell = require("./TableHeaderCell.context");
var _TableHeaderCell2 = require("./TableHeaderCell.styles");
var _excluded = ["scope"];
/**
 * A native [`<th>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/td) element.
 *
 * @since 8.0.0
 */
var TableHeaderCell = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var scope = _ref.scope,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_TableHeaderCell.TableHeaderCellContext);
  var headerScope = scope || (context.parent === 'body' ? 'row' : 'col');
  return /*#__PURE__*/_react.default.createElement(_TableHeaderCell2.StyledTableHeaderCell, (0, _extends2.default)({
    as: "th",
    ref: forwardedRef,
    scope: headerScope
  }, rest));
});
exports.TableHeaderCell = TableHeaderCell;
TableHeaderCell.displayName = 'Table.HeaderCell';
TableHeaderCell.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Tells assistive technologies whether this is a column header or a row header.
   * Unless a value is provided, <Table.HeaderCell> will automatically be assigned
   * a `scope="col"` or `scope="row"` attribute based on its parent.
   */
  scope: _propTypes.default.oneOf(['row', 'col', 'rowgroup', 'colgroup', 'auto'])
} : {};
TableHeaderCell.defaultProps = {
  scope: undefined
};